import React, { useContext, useEffect, useRef, useState } from 'react'
import { AuthContext } from '../../context/AuthContext'
import { useHttp } from '../../hooks/http.hook'
import { observer } from 'mobx-react'
import Modal from '../Modal'
import ModalForm from './ModalForm/ModalForm'
import LiveSearchInput from '../Inputs/LiveSearchInput/LiveSearchInput'
import { daDataRequest } from '../../api.external/daDataRequest'
import FormInput from '../Inputs/FormInput/FormInput'
import RadioCheckInput from '../Inputs/RadioCheckbox/RadioCheckInput'
import PropTypes from 'prop-types'

import styled from 'styled-components'

const DaDataModal2 = observer((props) => {
  const { request } = useHttp()
  const baseURl = process.env.REACT_APP_BASE_URL
  const { token } = useContext(AuthContext)
  const [status, setStatus] = useState()
  const [data, setData] = useState()

  const [daData, setDaData] = useState()
  const [formData, setFormData] = useState({
    role: '',
    name: '',
    inn: '',
    kpp: '',
    payed: '',
    address: '',
	fileData: '',
    ogrn: '',
    license: '',
  })
  const [fileData, setFileData] = useState()

  const nameRef = useRef()
  const innRef = useRef()
  const kppRef = useRef()
  const addressRef = useRef()
  const ogrnRef = useRef()
  const licenseRef = useRef()


  const editOrg = async (e) => {
    e.preventDefault()
    const url = `${baseURl}${props.url}`
	console.log('PUT TO URL', `${baseURl}${props.url}`)

    try {
      const { data, status } = await request(url, 'PUT', formData, { Authorization: `Bearer ${token.token}` })
      setStatus(status)
      setData(data)
    } catch (e) {

    }

  }


  const daDataInputHandler = (e) => {
    daDataRequest(e.target.value, setDaData)
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  const inputHandler = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  function optionClickHandler(kpp, inn) {
    daData.forEach(item => {
      if (item.data?.kpp === kpp && inn === item.data?.inn) {
        innRef.current.value = item.data.inn
        nameRef.current.value = item.data.name?.short || item.data.name?.full
        kppRef.current.value = item.data.kpp  || ""
        addressRef.current.value = item.data.address.value

        setFormData({
          ...formData,
          name: nameRef.current.value,
          inn: innRef.current.value,
          kpp: kppRef.current.value,
          address: addressRef.current.value
        })

      }
    })
  }
  
  const handleFileChange=(evt)=>{
	const f = evt.target.files[0];
	const reader = new FileReader();
	reader.addEventListener("load", () => {
		setFormData({ ...formData, fileData: reader.result })
	}, false);
	if (f) {
		reader.readAsDataURL(f);
	}
  }

  useEffect(() => {
    if (props.data) {
      setFormData({ ...props.data })
    }
  }, [props.data])

  return (
    <Modal styles={{ left: '90px', zIndex: '101' }}>


      <ModalForm closeHandler={props.closeHandler} onSubmit={editOrg}
                 readyText={'Контрагент изменен.'}
                 readyBtnText={'Продолжить'}
                 ready={status === 200}
                 submitDisabled={!(
                   formData.payed &&
                   formData.role && formData.name && formData.inn)}
                 onSubmitTitle={'Сохранить'}
                 title={'Карта контрагента организации (2)'}
                 errors={{
                   reqError: { message: status === 400 ? data?.message : '' },
                   reqErrorOk: { message: status === 200 && data?.message !== 'ok'&& data?.message !== 'Данные успешно обновлены' ? data?.message : '' }
                 }}
      >


      <LiveSearchInput optionClickHandler={optionClickHandler}
                       reff={nameRef}
                       name={'name'}
                       value={formData.name}
                       storage={daData}
                       onChange={daDataInputHandler}
                       id={'inn'}
                       title={<>Название <span style={{ color: 'red' }}>*</span></>} />

      <LiveSearchInput optionClickHandler={optionClickHandler}
                       name={'inn'}
                       value={formData.inn}
                       reff={innRef}
                       storage={daData}
                       onChange={daDataInputHandler}
                       id={'inn'}
                       title={<>ИНН <span style={{ color: 'red' }}>*</span></>} />

      <FormInput value={formData.kpp} onChange={inputHandler} reff={kppRef} name={'kpp'} hideIcon
                 title={'КПП'} />
      <FormInput value={formData.address} onChange={inputHandler} reff={addressRef} name={'address'} hideIcon
                 title={'Адрес'} />
      <FormInput value={formData.email} onChange={inputHandler} name={'email'} hideIcon type={'email'}
                 title={'E-Mail'} />

      <div style={{ width: '100%', marginTop: '20px' }}>
        <div style={{ marginBottom: '20px' }}>Вид организации <span style={{ color: 'red' }}>*</span></div>
        <RadioCheckInput checked={formData.role == 5} name={'role'} onChange={inputHandler} value={5}
                         id={'def2'}
                         title={'Удостоверяющий центр'} />
        <RadioCheckInput checked={formData.role == 4} name={'role'} onChange={inputHandler} value={4}
                         id={'def2'}
                         title={'Мед. центр'} />
        <RadioCheckInput checked={formData.role == 3} name={'role'} onChange={inputHandler} value={3}
                         id={'def2'}
                         title={'Организация'} />
        <div style={{ marginBottom: '20px', marginTop: '20px' }}>
          Дебиторская задолженность <span
          style={{ color: 'red' }}>*</span></div>

        <RadioCheckInput checked={
          formData.payed === 'true' || formData.payed === true}

                         name={'payed'} onChange={inputHandler}
                         value={true}
                         id={'def3'}
                         title={'Да'} />
        <RadioCheckInput checked={
          formData.payed === 'false' || formData.payed === false} name={'payed'}
                         onChange={inputHandler}
                         value={false}
                         id={'defj3'}
                         title={'Нет'} />
						 
		{formData.role == 5 ? <>
			<div style={{ marginBottom: '20px', marginTop: '20px' }}>
			<div style={{ marginBottom: '3px', marginTop: '3px' }}>
			  Логотип </div>
			  <label for="setlogofile" style={{textDecoration: 'underline'}}>(кликните если нужно сменить)</label>
			  <input id="setlogofile" type="file" name="setlogo" style={{display: 'none'}} onChange={handleFileChange} accept="image/png"/>
			</div>
			<FormInput value={formData.ogrn} onChange={inputHandler} reff={ogrnRef} name={'ogrn'} hideIcon
                 title={'ОГРН'} />
			<FormInput value={formData.license} onChange={inputHandler} reff={licenseRef} name={'license'} hideIcon
                 title={'Лицензия'} />
		</> : undefined}
		  
      </div>

    </ModalForm>
</Modal>
)
})

DaDataModal2.propTypes = {
url: PropTypes.string.isRequired,
closeHandler: PropTypes.func,
data: PropTypes.shape({
name: PropTypes.string
})
}


const AttentionWrapper = styled.div`
min-height: 50px;
min-width: 50px;
margin-bottom: 20px;
`
export default DaDataModal2
